// extracted by mini-css-extract-plugin
export default {"viewer":"SyncFusionPdfViewer_viewer__MXLyQ"};